"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
// @ts-ignore
const PasswordInput = (_a) => {
    var { name, placeholder, onChange } = _a, rest = __rest(_a, ["name", "placeholder", "onChange"]);
    const [passwordVisible, setPasswordVisible] = (0, react_1.useState)(false);
    return (react_1.default.createElement(components_1.Input, Object.assign({}, rest, { type: passwordVisible ? 'text' : 'password', placeholder: placeholder, name: name, onChange: onChange, onToggleViewPassword: (visible) => setPasswordVisible(visible) })));
};
PasswordInput.defaultProps = {
    viewPasswordImage: {
        open: { default: constants_1.Images.eye, active: constants_1.Images.eyeActive, error: constants_1.Images.eyeError },
        close: {
            default: constants_1.Images.eyeClose,
            active: constants_1.Images.eyeCloseActive,
            error: constants_1.Images.eyeCloseError,
        },
    },
    placeholder: constants_1.default.login.enterPassword,
};
exports.default = PasswordInput;
